import { render, staticRenderFns } from "./HeaderFooter.vue?vue&type=template&id=f07358fc&scoped=true&"
import script from "./HeaderFooter.vue?vue&type=script&lang=js&"
export * from "./HeaderFooter.vue?vue&type=script&lang=js&"
import style0 from "./HeaderFooter.vue?vue&type=style&index=0&id=f07358fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07358fc",
  null
  
)

export default component.exports